import gql from 'graphql-tag'

import { Query } from '../types-graphql'
import { areaFragment } from './fragments'

export type TDataAreas = Pick<Query, 'areas' | '__typename'>
export const AREAS = gql`
  query (
    $parentId: ID
    $idOrParentId: ID
    $q: AreaRansack
    $perPage: Int
    $page: Int
  ) {
    areas(
      idOrParentId: $idOrParentId
      parentId: $parentId
      q: $q
      perPage: $perPage
      page: $page
    ) {
      nodes {
        ...AreaFragment
      }
      pagesCount
      nodesCount
      hasNextPage
      hasPreviousPage
    }
  }
  ${areaFragment}
`

export type TDataArea = Pick<Query, 'area' | '__typename'>
export const AREA = gql`
  query ($id: ID!, $q: AreaRansack) {
    area(id: $id, q: $q) {
      ...AreaFragment
    }
  }
  ${areaFragment}
`
